import { styled, Box } from '@mui/material';

export const UPFileInputFieldWrapper = styled(Box)({
  position: 'relative',
});

export const UPFileInputStyled = styled('input')(({ disabled }) => ({
  opacity: 0,
  zIndex: 1,
  position: 'absolute',
  height: '100%',
  width: '100%',
  cursor: 'pointer',
  top: 0,
  left: 0,
  // Disabled still leaves this transparent input hoverable, so the browser's native "No file
  // chosen" tooltip for an empty file input shows anyway — pointer-events: none stops the mouse
  // from ever entering it.
  ...(disabled && { pointerEvents: 'none' }),
}));

export const UIFileInputAttachmentIconContainer = styled(Box)(() => ({
  cursor: 'pointer',
  width: '24px',
  height: '24px',
  marginRight: '8px',
}));

export const UIFileInputClearIconContainer = styled(UIFileInputAttachmentIconContainer)({
  position: 'relative',
  zIndex: 2,
});

export const UIFileInputSpinner = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  marginRight: '8px',
});
